var paymentOverlay =
	'<div id="stripeoverlay" style="position: fixed; filter: alpha(opacity=80); top: 0px; left: 0px; width: 100%; height: 100%; display: block; opacity: 0.7; z-index: 10001; background-color: black;"><div style="color: #fff; font-size: 17px; font-weight: bolder;position:absolute; width: 160px;margin-left: -80px; margin-top: -30px; top: 50%; text-align: center;left:50%;">Payment in progress<br><img style="margin-top:10px" src="data:image/gif;base64,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"/></div></div>';

$(function () {
    const $dispatchForm = $("#dispatch-address-form");
    const $billingForm = $("#billing-address-form");
    const billingToggle = document.getElementById("billing-toggle");

	$("#dispatch-form-btn").on("click", function (event) {
        event.preventDefault();

		// When the cart is locked by a payment in progress there is no shipping
		// (or billing) form to validate: skip those steps, run the payment method
		// check and go straight to the payment page with the selected method
		if ($dispatchForm.length === 0) {
			if (!validatePaymentMethodSelection()) {
				return;
			}
			const paymentMethod = $('[name="payment-method"]:checked').val();
			const url = new URL("/" + document.documentElement.lang + "/checkout/payment", window.location.origin);
			if (paymentMethod) {
				url.searchParams.set("payment-method", paymentMethod);
			}
			window.location.href = url.toString();
			return;
		}

		// if (billingToggle && billingToggle.checked) {
		// 	$("#billing_addressee").val($("#addressee").val());
		// 	$("#billing_country").val($("#country").val());
		// 	$("#billing_street").val($("#street").val());
		// 	$("#billing_number").val($("#number").val());
		// 	$("#billing_cap").val($("#cap").val());
		// 	$("#billing_city").val($("#city").val());
		// 	$("#billing_prov").val($("#prov").val());
		// }

		$dispatchForm.trigger("submit");
	});

    const invoiceModeSelect = $('#invoice-mode');
    const setInvoiceFormFields = () => {
        const invoiceMode = invoiceModeSelect.val();
        const form = invoiceModeSelect.closest('form');
        const thisColumn = invoiceModeSelect.closest('.column, .columns')[0];
        const columns = $(form).find('> .row > .column, > .row > .columns');

        for (const column of columns) {
            if (column !== thisColumn) {
                const enabled = !!invoiceMode && (!column.dataset.onlyFor || invoiceMode == column.dataset.onlyFor);
                column.classList.toggle('hide', !enabled);
                $(column).find('input, select').toArray().forEach(el => el.disabled = !enabled);
            }
        }
    }

    setInvoiceFormFields();
    invoiceModeSelect.on('change', setInvoiceFormFields);
    
    function setProperty(key, value) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "/restful/shopping/public/checkout/setproperty",
                method: "POST",
                data: {
                    key : key,
                    value: value
                },
                success: data => data.success ? resolve() : reject(),
                error: reject
            })
        });
    }

    $.validator.addMethod('pecOrSdi', (_, el) => {
        const otherInputName = el.name == 'pec' ? 'sdi' : 'pec';
        const otherInput = el.closest('form').querySelector(`[name="${otherInputName}"]`);
        return el.disabled || el.value.length > 0 || otherInput.value.length > 0;
    });
    $.validator.messages.pecOrSdi = msg['ERR_PEC_OR_SDI'];

	function validatePaymentMethodSelection() {
		const paymentMethods = Array.from(document.querySelectorAll('[name="payment-method"]'));

		if (paymentMethods.length > 0 && !paymentMethods.some(method => method.checked)) {
			showMessageBox('danger', msg['ERR_PAYMENT_METHOD']);
			$(paymentMethods).one('change', function() {
				$(paymentMethods).removeClass('error');
			});
			$(paymentMethods).addClass('error');
			window.scrollTo({ top: (document.getElementById('payment-methods')?.offsetTop ?? 0) - (document.querySelector('header')?.offsetHeight ?? 0) })
			return false;
		}

		return true;
	}

	$dispatchForm.validate({
        ignore: [],
        invalidHandler: () => {
            if ($("#dispatch-address-form-toggleable-fields").is(":hidden")) {
                $('#dispatch-address-toggle').trigger("click");
                showMessageBox("danger", msg['ERR_MISSINGFIELDS']);
            }
        },
		submitHandler: () => {
            const privacy = document.getElementById('clausola');

            if (!validatePaymentMethodSelection()) {
                return;
            } 

            if (privacy && !privacy.checked) {
                showMessageBox('danger', msg['ERR_PRIVACY']);
                $(privacy).one('change', function() {
                    privacy.classList.remove('error');
                });
                privacy.classList.add('error');
                privacy.focus();
                return;
            }

            if ($dispatchForm.is('.virtual-shipping')) {
                Promise.all([
                    setProperty('giftcard_sender', $dispatchForm.find('[name=giftcard_sender]').val()),
                    setProperty('giftcard_recipient', $dispatchForm.find('[name=giftcard_recipient]').val()),
                    setProperty('giftcard_text', $dispatchForm.find('[name=giftcard_text]').val()),
                    setProperty('giftcard_date', $dispatchForm.find('[name=giftcard_date]').val())
                ])
                .then(() => submitFormIntangible($dispatchForm))
                .catch(() => showMessageBox('error', msg['MSG_GENERIC_ERROR']));
            }
            else {
                submitForm($dispatchForm, true);
            }
        }
	});

	$billingForm.validate({
        rules: {
            pec: 'pecOrSdi',
            sdi: 'pecOrSdi'
        },
		invalidHandler: function (_, validator) {
            window.scrollTo({ top: validator.invalidElements()[0].offsetTop - document.querySelector('header')?.offsetTop ?? 0 });
		},
        submitHandler: submitForm
    })

	function submitFormIntangible(form) {
		const $form = $(form);
		const emailValue = $('input[name="email"]').val();

		$.ajax({
			method: $form.attr("method"),
			url: $form.attr("action"),
			data: {
				email: emailValue,
				country_id: 108,
				street: "-",
				number: 1,
				cap: 10100,
				city: "-",
				addressee: "-",
				state: "-",
				updateType: "dispatch",
				prov: "-",
				clausola1: "on",
			},
			dataType: "json",
			success: function (data) {
                if (data.success) {
                    const url = new URL($form.data("nextstep"), window.location.origin);
                    const paymentMethod = $('[name="payment-method"]:checked').val();
                    url.searchParams.set('payment-method', paymentMethod);
                    window.location.href = url.toString();
                }
                else {
                    showMessageBox("danger", msg["MSG_GENERIC_ERROR"]);
                }
			},
			error: function () {
				showMessageBox("danger", msg["MSG_GENERIC_ERROR"]);
			},
		});
	}

	function submitForm(form, shippingForm=false) {
		const $form = $(form);

		$.ajax({
			method: $form.attr("method"),
			url: $form.attr("action"),
			data: $form.serialize() + '&clausola1=on',
			dataType: "json",
			success: function (data) {
                if (data.success) {
                    if (shippingForm) {
                        setProperty('fattura-richiesta', (billingToggle && billingToggle.checked) ? 'si' : 'no')
                            .then(() => {
                                if (billingToggle && billingToggle.checked) {
                                    if ($billingForm.valid()) {
                                        submitForm($billingForm);
                                    }
                                }
                                else {
                                    goToNextPage();
                                }
                            })
                            .catch(() => showMessageBox("danger", msg["MSG_GENERIC_ERROR"]));
                    }
                    else {
                        setProperty('tipo-fattura', invoiceModeSelect.val())
                            .then(goToNextPage)
                            .catch(() => showMessageBox("danger", msg["MSG_GENERIC_ERROR"]));
                    }
                }
                else {
                    showMessageBox("danger", msg[data.errors.message] ?? msg["MSG_GENERIC_ERROR"]);
                }
			},
			error: function () {
				showMessageBox("danger", msg["MSG_GENERIC_ERROR"]);
			},
		});
	}
    function goToNextPage() {
        const url = new URL($billingForm.data("nextstep"), window.location.origin);
        const paymentMethod = $('[name="payment-method"]:checked').val();
        url.searchParams.set('payment-method', paymentMethod);
        
        if (window.dataLayer) {
            dataLayer.push({ ecommerce: null });
            pushGTMEventWithCallback(500, {
                event: 'add_shipping_info',
                ecommerce: window.ecommerce,
                eventCallback: GTMCallback(function() {
                    window.location.href = url.toString();
                })
            });
        }
        else {
            window.location.href = url.toString();
        }
    }

	$(billingToggle).on("change", function() {
        if (this.checked) {
            $("#billing-address-form").slideDown();
        }
        else {
            $("#billing-address-form").slideUp();
        }
	});

    $('#dispatch-address-form #country').on('change', function() {
        const input = this;
        showQuestionBox(msg['MSG_WARN_CHANGE_COUNTRY'], '',
            () => {
                $.ajax({
                    url: '/restful/carrier/change',
                    method: 'POST',
                    data: {
                        carrier_id: 0,
                        country_id: input.value
                    },
                    dataType: 'json',
                    success: data => {
                        if (data.success) {
                            const cartSummary = $('.cart-resume__space');
                            const paymentMethods = $('#payment-methods');

                            cartSummary.css({'opacity': .5, 'pointer-events': 'none'});
                            paymentMethods.css({'opacity': .5, 'pointer-events': 'none'});
                            new Promise((resolve, reject) => {
                                $.ajax({
                                    url: window.location.href,
                                    method: 'GET',
                                    dataType: 'html',
                                    cache: false,
                                    success: function(data) {
                                        resolve($(data));
                                    },
                                    error: function() {
                                        reject();
                                    }
                                });
                            })
                            .then(document => {
                                cartSummary.replaceWith(document.find('.cart-resume__space'));
                                paymentMethods.replaceWith(document.find('#payment-methods'));
                            })
                            .catch(() => window.location.reload());

                            input.dataset.currentCountryId = input.value;
                        }
                        else {
                            window.location.reload();
                        }
                    },
                    error: () => {
                        window.location.reload();
                    }
                })
            },
            () => {
                input.value = input.dataset.currentCountryId;
            }
        );
    });

    $('#save-shipping').on("click", function() {
        $(this).closest('form').find('input, select').each(function() {
            if (this.name == 'country_id') {
                const countryName = $(this).find('option:selected').text();
                $(`#current-address-country`).text(countryName);
            }
            else {
                const span = $(`#current-address-${this.name}`);
                span.text(`${this.value.length > 0 ? span.data('prefix') ?? '': ''}${this.value}`);
            }
        });

        $('#dispatch-address-toggle').trigger("click");
    });

    const paymentButton = document.getElementById('payment-btn');

    $('[name="payment-method"]').on('change', function() {
        const paypalButton = document.getElementById('paypalBraintreeButton');

        if (paypalButton && this.checked) {
            if (this.value == 'payment-braintree') {
                paypalButton.style.removeProperty('display');
                paymentButton.style.display = 'none';
            }
            else {
                paymentButton.style.removeProperty('display');
                paypalButton.style.display = 'none';
            }
        }
    });

    $('[name="payment-method"]:checked').trigger('change');

    $(paymentButton).on("click", function() {
        const paymentMethod = $('[name="payment-method"]:checked').val();
        const form = $(`#${paymentMethod}-form`)[0];

        if (paymentMethod == 'payment-booking' && window.dataLayer) {
            dataLayer.push({ ecommerce: null });
            pushGTMEventWithCallback(500, {
                event: 'add_payment_info',
                ecommerce: window.ecommerce('Booking'),
                eventCallback: GTMCallback(function() {
                    if (form.requestSubmit) {
                        form.requestSubmit();
                    }
                    else {
                        form.submit();
                    }
                })
            });
        }
        else {
            if (form.requestSubmit) {
                form.requestSubmit();
            }
            else {
                $(form).trigger('submit');
            }
        }
    });

	$('[name*="country"]').on("change", updateProvinces);
	updateProvinces();

	function updateProvinces() {
		$('[name*="prov"]').each(function () {
			const $this = $(this);
			const country = $this.closest("form").find('[name*="country"]');

			if (country.length > 0) {
				loadProvinces(country.val()).then(function (provinces) {
                    if (provinces.length > 0) {
                        const id = $this.attr('id');
                        const name = $this.attr('name');
                        const type = $this.attr('type');
                        const value = $this.val();
                        const placeholder = $this.attr('placeholder');
                        const disabled = $this.is('[disabled], [readonly]') ? 'disabled' : '';
                        const readonly = $this.is('[readonly]') ? 'readonly' : '';
                        const required = $this.is('[required]') ? 'required' : '';
                        let options = [`<option class="hide" disabled selected>${msg['MSG_SELECT_PROVINCE']}</option>`];
                        let hasSelectedValue = false;
    
                        for (let i = 0; i < provinces.length; i++) {
                            const province = provinces[i];
                            const selected = (province.code == value) ? 'selected' : '';
                            options.push(`<option value="${province.code}" ${selected}>${province.name} (${province.code})</option>`);
                            hasSelectedValue = hasSelectedValue || (province.code == value);
                        }
                        if (!hasSelectedValue) {
                            options[0].replace('  ', ' selected');
                        }
                        
                        if (readonly) {
                            $(`<input type="hidden" name="${name}" value="${value}" ${required}/>`).insertAfter($this);
                        }
    
                        $this.replaceWith(`
                            <select id="${id}" name="${name}" ${disabled} ${readonly} data-type="${type}" ${required} data-placeholder="${placeholder}" data-value="${value}">
                                ${options.join('\n')}
                            </select>
                        `);
                    }
                    else if ($this.is('select')) {
                        const id = $this.attr('id');
                        const name = $this.attr('name');
                        const type = $this.data('type');
                        const value = $this.data('value');
                        const placeholder = $this.data('placeholder');
                        const disabled = $this.is('[disabled]:not([readonly])') ? 'disabled' : '';
                        const readonly = $this.is('[readonly]') ? 'readonly' : '';
                        const required = $this.is('[required]') ? 'required' : '';
                        
                        if (readonly) {
                            $this.siblings(`[name=${name}][type=hidden]`).remove();
                        }
    
                        $this.replaceWith(`<input id="${id}" type="${type}" name="${name}" ${disabled} ${readonly} ${required} value="${value}" placeholder="${placeholder}"/>`);
                    }
				});
			}
		});
	}
});
